import { useEffect } from 'react';
import { Routes as ReactRoutes, Route, useLocation } from 'react-router-dom';

import Layout from 'components/Layout';
import Home from './Home';
import Chat from './Chat';

import { useAnalytics } from 'hooks/useAnalytics';
import { useAppConfig } from 'hooks/appConfig';
import { htmlId } from 'utils/html';

import { ROUTES } from './constants';
import { ANALYTICS } from 'analytics/constants';
import { ACTIONS } from 'constants/hook';
import Debug from './Debug';

const Routes = () => {
  const location = useLocation();
  const { trackEvent } = useAnalytics();
  const { dispatchAppConfigAction, appConfigState } = useAppConfig();

  /** Insert globally impacted experiments into appConfigState **/
  const setGlobalExperiments = async () => {
    dispatchAppConfigAction({
      type: ACTIONS.CHANGE,
      payload: {
        ...appConfigState,
        experiments: {
          ...appConfigState.experiments,
        },
      },
    });
  };

  useEffect(() => {
    setGlobalExperiments();
  }, []);

  useEffect(() => {
    trackEvent({
      analyticEvent: ANALYTICS.EVENT.VIEW_DISPLAYED,
    });
  }, [location]);

  return (
    <ReactRoutes>
      <Route id={htmlId('route-home')} path={ROUTES.HOME} element={<Layout />}>
        <Route id={htmlId('route-index')} index element={<Home />} />
        <Route id={htmlId('route-chat')} path={ROUTES.CHAT} element={<Chat />} />
        <Route id={htmlId('route-debug')} path={ROUTES.DEBUG} element={<Debug />}></Route>
      </Route>
    </ReactRoutes>
  );
};

export default Routes;
